export const API_ORDERED_FIELD_NAMES = {
  personal_information: [
    'representatives',
    'name_prefix',
    'name_first',
    'name_middle',
    'name_last',
    'name_second_surname',
    'name_suffix',
    'address_line_1',
    'address_line_2',
    'address_city',
    'address_state',
    'address_postal_code',
    'address_country_code',
    'address_complete',
    'phone_number',
    'email_address',
    'gender',
    'birth_date',
  ],
  document_information: [
    'document_token_front',
    'document_token_back',
    'document_ssn',
    'document_ssn_last4',
    'document_license',
    'document_license_state',
    'document_passport',
    'document_passport_nationality',
    'document_national_id',
  ],
  social: [
    'social_twitter',
    'social_facebook',
  ],
  transaction: [
    'external_counterparty_id',
  ],
  business_information: [
    'business_name',
    'business_alternate_name',
    'business_federal_ein',
    'business_email_address',
    'business_phone_number',
    'federal_ein',
    'business_address_line_1',
    'business_address_line_2',
    'business_address_city',
    'business_address_state',
    'business_address_postal_code',
    'business_address_country_code',
    'business_address_complete',
    'business_type',
    'business_registry_id',
  ],
};

export const ADDRESS_ORDERED_FIELD_NAME = [
  'name_prefix',
  'name_first',
  'name_middle',
  'name_last',
  'name_second_surname',
  'name_suffix',
  'line_1',
  'line_2',
  'city',
  'state',
  'postal_code',
  'country_code',
  'years_at_address',
  'months_at_address',
  'type',
];

export const REPRESENTATIVE_FIELDS = [
  'name_first',
  'name_middle',
  'name_last',
  'name_suffix',
  'document_ssn',
  'phone_number',
  'phone_number_work',
  'document_license_state',
  'birth_date',
  'email_address',
  'gender',
  'type',
];

export const FORMAT_ADDRESS_FIELDS = [
  'line_1',
  'line_2',
  'city',
  'state',
  'postal_code',
  'country_code',
  'years_at_address',
  'months_at_address',
];

export const ADDRESS_FIELDS = [
  'address_line_1',
  'address_line_2',
  'address_city',
  'address_us_state',
  'address_state',
  'address_postal_code',
  'address_country_code',
  'address_complete',
];

export const BUSINESS_ADDRESS_FIELDS = [
  'business_address_line_1',
  'business_address_line_2',
  'business_address_city',
  'business_address_us_state',
  'business_address_state',
  'business_address_postal_code',
  'business_address_country_code',
  'business_address_complete',
];

export const ADDRESS_FIELDS_DICT = {
  address_line_1: 'line_1',
  address_line_2: 'line_2',
  address_city: 'city',
  address_us_state: 'us_state',
  address_state: 'state',
  address_postal_code: 'postal_code',
  address_country_code: 'country_code',
  address_complete: 'complete',
};

export const BUSINESS_ADDRESS_FIELDS_DICT = {
  business_address_line_1: 'line_1',
  business_address_line_2: 'line_2',
  business_address_city: 'city',
  business_address_us_state: 'us_state',
  business_address_state: 'state',
  business_address_postal_code: 'postal_code',
  business_address_country_code: 'country_code',
  business_address_complete: 'complete',
  business_address_type: 'type',
};

/*
data provided by http://departments.weber.edu/qsupport&training/data_standards/name.htm#PREFIX
*/
export const PREFIX_LIST = [
  '1st Lt',
  'Adm',
  'Atty',
  'Brother',
  'Capt',
  'Chief',
  'Cmdr',
  'Col',
  'Dean',
  'Dr',
  'Elder',
  'Father',
  'Gen',
  'Gov',
  'Hon',
  'Lt Col',
  'Maj',
  'MSgt',
  'Mr',
  'Mrs',
  'Ms',
  'Prince',
  'Prof',
  'Rabbi',
  'Rev',
  'Sister',
];
/*
data provided by http://departments.weber.edu/qsupport&training/data_standards/name.htm#SUFFIX
*/
export const SUFFIX_LIST = [
  'II',
  'III',
  'IV',
  'CPA',
  'DDS',
  'Esq',
  'JD',
  'Jr',
  'LLD',
  'MD',
  'PhD',
  'Ret',
  'RN',
  'Sr',
  'DO',
];
